import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Award, Users } from "lucide-react";

const FullLeaderboardModal = ({ isOpen, onClose, leaderboard = [] }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-slate-900 rounded-2xl p-6 w-full max-w-3xl mx-4 border border-slate-700 shadow-xl"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-white">
                Full Leaderboard
              </h2>
              <button
                onClick={onClose}
                className="text-slate-400 hover:text-white"
              >
                <X size={24} />
              </button>
            </div>
            {/* Leaderboard List */}
            <div className="max-h-96 overflow-y-auto space-y-3">
              {leaderboard.length > 0 ? (
                leaderboard.map((leader, index) => (
                  <div
                    key={leader.id || index}
                    className="flex items-center gap-3 py-2 px-4 rounded-lg bg-slate-800/30 border border-slate-700/50"
                  >
                    <div className="w-6 h-6 rounded-full flex items-center justify-center bg-slate-700/50 text-slate-400 text-xs font-bold">
                      {index + 1}
                    </div>
                    <div className="w-8 h-8 rounded-full overflow-hidden bg-slate-700">
                      {leader.avatar ? (
                        <img
                          src={leader.avatar}
                          alt={leader.name}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="flex items-center justify-center w-full h-full">
                          <Users size={16} className="text-slate-400" />
                        </div>
                      )}
                    </div>
                    <div className="flex-1">
                      <p className="text-sm text-white font-medium">
                        {leader.name}
                      </p>
                      <p className="text-xs text-slate-400">{leader.game}</p>
                    </div>
                    <div className="flex items-center gap-1">
                      <Award size={14} className="text-purple-400" />
                      <span className="text-white font-mono">
                        {leader.score.toLocaleString()}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-slate-400">No leaderboard data available.</p>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FullLeaderboardModal;
